import { React, useState, useEffect } from 'react';
import styled from 'styled-components';
import { useLanguage } from '../../../Context/LanguageContext';
import { useTheme } from '../../../Context/ThemeContext';
import { lightTheme, darkTheme } from '../../../Styles/theme';

import MembershipSortingSelectBox from '../../../Component/MemberComponent/MembershipSortingSelectBox';

import NormalSortButtonPath from '../../../image/GrayNormalSortButton2.png';
import AscSortButtonPath from '../../../image/AscSortButton2.png';
import DescSortButtonPath from '../../../image/DescSortButton2.png';

const ValidColumnView = (props) => {
  const { 
    selectedMembership,
    setSelectedMembership,
    genderSort,
    setGenderSort,
    birthSort,
    setBirthSort,
    startSort, 
    setStartSort, 
    endSort, 
    setEndSort, 
    classSort, 
    setClassSort 
  } = props;
  const { t } = useLanguage();

  const { isDark } = useTheme();
  const theme = isDark ? darkTheme : lightTheme;

  const [genderButtonImg, setGenderButtonImg] = useState(AscSortButtonPath);
  const [birthButtonImg, setBirthButtonImg] = useState(AscSortButtonPath);
  const [startButtonImg, setStartButtonImg] = useState(AscSortButtonPath);
  const [endButtonImg, setEndButtonImg] = useState(AscSortButtonPath);
  const [classButtonImg, setClassButtonImg] = useState(AscSortButtonPath);


  // 성별 버튼 클릭시 이미지 변경 //
  useEffect(() => {
    if (genderSort === 'normal') setGenderButtonImg(NormalSortButtonPath);
    else if (genderSort === 'asc') setGenderButtonImg(AscSortButtonPath);
    else if (genderSort === 'desc') setGenderButtonImg(DescSortButtonPath);
  }, [genderSort])

  // 생년월일 버튼 클릭시 이미지 변경 //
  useEffect(() => {
    if (birthSort === 'normal') setBirthButtonImg(NormalSortButtonPath);
    else if (birthSort === 'asc') setBirthButtonImg(AscSortButtonPath);
    else if (birthSort === 'desc') setBirthButtonImg(DescSortButtonPath);
  }, [birthSort])

  // 시작일 버튼 클릭시 이미지 변경 //
  useEffect(() => {
    if (startSort === 'normal') setStartButtonImg(NormalSortButtonPath);
    else if (startSort === 'asc') setStartButtonImg(AscSortButtonPath);
    else if (startSort === 'desc') setStartButtonImg(DescSortButtonPath);
  }, [startSort])

  // 종료일 버튼 클릭시 이미지 변경 //
  useEffect(() => {
    if (endSort === 'normal') setEndButtonImg(NormalSortButtonPath);
    else if (endSort === 'asc') setEndButtonImg(AscSortButtonPath);
    else if (endSort === 'desc') setEndButtonImg(DescSortButtonPath);
  }, [endSort])

  // 수업 버튼 클릭시 이미지 변경 //
  useEffect(() => {
    if (classSort === 'normal') setClassButtonImg(NormalSortButtonPath);
    else if (classSort === 'asc') setClassButtonImg(AscSortButtonPath);
    else if (classSort === 'desc') setClassButtonImg(DescSortButtonPath);
  }, [classSort])

  // 성별 정렬 버튼 클릭시 //
  function onClickGenderSort() {
    setBirthSort('normal');
    setStartSort('normal');
    setEndSort('normal');
    setClassSort('normal');

    if (genderSort === 'normal' || genderSort === 'desc') setGenderSort('asc');
    else if (genderSort === 'asc') setGenderSort('desc');
  }

  // 생년월일 정렬 버튼 클릭시 //
  function onClickBirthSort() {
    setGenderSort('normal');
    setStartSort('normal');
    setEndSort('normal');
    setClassSort('normal');

    if (birthSort === 'normal' || birthSort === 'desc') setBirthSort('asc');
    else if (birthSort === 'asc') setBirthSort('desc');
  }

  // 종료일 정렬 버튼 클릭시 //
  function onClickStartSort() {
    setGenderSort('normal');
    setBirthSort('normal');
    setEndSort('normal');
    setClassSort('normal');

    if (startSort === 'normal' || startSort === 'desc') setStartSort('asc');
    else if (startSort === 'asc') setStartSort('desc');
  }

  // 종료일 정렬 버튼 클릭시 //
  function onClickEndSort() {
    setGenderSort('normal');
    setBirthSort('normal');
    setStartSort('normal');
    setClassSort('normal');

    if (endSort === 'normal' || endSort === 'desc') setEndSort('asc');
    else if (endSort === 'asc') setEndSort('desc');
  }

  return (
    <TopLevelWrapper>
      <Column style={{marginLeft: '28px'}} width={64}>
        <Text fontFamily='NotoSansKR-Medium' fontSize={14} color={theme.text} cursor='default'>{t('validMember.colName')}</Text>
      </Column>
      <SortingWrapper width={72}>
        <Text fontFamily='NotoSansKR-Medium' fontSize={14} color={theme.text} cursor='default'>{t('validMember.colGender')}</Text>
      <SortingButton src={genderButtonImg} onClick={() => onClickGenderSort()}/>
      </SortingWrapper>
      <SortingWrapper width={106}>
        <Text fontFamily='NotoSansKR-Medium' fontSize={14} color={theme.text} cursor='default'>{t('validMember.colBirth')}</Text>
        <SortingButton src={birthButtonImg} onClick={() => onClickBirthSort()}/>
      </SortingWrapper>
      <Column width={106}>
        <Text fontFamily='NotoSansKR-Medium' fontSize={14} color={theme.text} cursor='default'>{t('validMember.colPhone')}</Text>
      </Column>
      <SortingWrapper width={234}>
        <Text fontFamily='NotoSansKR-Medium' fontSize={14} color={theme.text} cursor='default'>{t('validMember.colMembership')}</Text>
        <MembershipSortingSelectBox
          value={selectedMembership}
          setValue={setSelectedMembership} />
      </SortingWrapper>
      <SortingWrapper width={86}>
        <Text fontFamily='NotoSansKR-Medium' fontSize={14} color={theme.text} cursor='default'>{t('validMember.colStartDate')}</Text>
        <SortingButton src={startButtonImg} onClick={() => onClickStartSort()}/>
      </SortingWrapper>
      <SortingWrapper width={174}>
        <Text fontFamily='NotoSansKR-Medium' fontSize={14} color={theme.text} cursor='default'>{t('validMember.colEndDate')}</Text>
        <SortingButton src={endButtonImg} onClick={() => onClickEndSort()}/>
      </SortingWrapper>
      <Column width={80}>
        <Text fontFamily='NotoSansKR-Medium' fontSize={14} color={theme.text} cursor='default'>{t('validMember.colCount')}</Text>
      </Column>
    </TopLevelWrapper>
  )
}

export default ValidColumnView;

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: row;

  align-items: center;

  width: 1020px;

  margin-top: 34px;

  gap: 8px;
`;

const SortingWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: flex-start;

  width: ${props => props.width}px;
  height: 20px;

  gap: 4px;

  overflow: hidden;
`;

const SortingButton = styled.img`
  display: flex;

  justify-content: center;
  align-items: center;

  width: 20px;
  height: 20px;

  border-radius: 4px;

  overflow: hidden;

  transition: all 0.3s ease-in-out;

  &:hover {
    cursor: pointer;
  }
`;

const Column = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: flex-start;

  width: ${props => props.width}px;
  height: 20px;

  overflow: hidden;
`;

const Text = styled.p`
  font-family: ${props => props.fontFamily};
  font-size: ${props => props.fontSize}px;

  color: ${props => props.color};

  margin: 0 0 0 0;

  &:hover {
    cursor: ${props => props.cursor};
  }

  transition: all 0.3s ease-in-out;
`;